import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { CheckCircle, X } from "@phosphor-icons/react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("No unsubscribe token provided.");
      return;
    }
    api
      .post(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setStatus("ok");
        setMessage(`${res.data.email} has been unsubscribed.`);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(formatApiError(err.response?.data?.detail) || "Could not unsubscribe.");
      });
  }, [token]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6 py-16">
      <div className="w-full max-w-md border border-white/10 bg-[#0a0a0a] p-10 text-center">
        {status === "loading" && <div className="text-sm uppercase tracking-[0.2em] text-white/60">Processing…</div>}
        {status === "ok" && (
          <>
            <CheckCircle size={48} weight="bold" className="mx-auto text-[#D4FF00]" />
            <h1 className="mt-4 font-display text-3xl font-bold tracking-tighter">Unsubscribed</h1>
            <p className="mt-2 text-sm text-white/60">{message}</p>
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-white/40">You won't receive any more emails from us.</p>
          </>
        )}
        {status === "error" && (
          <>
            <X size={48} weight="bold" className="mx-auto text-red-400" />
            <h1 className="mt-4 font-display text-3xl font-bold tracking-tighter">Something went wrong</h1>
            <p className="mt-2 text-sm text-white/60">{message}</p>
          </>
        )}
      </div>
    </div>
  );
}
